<template>
  <div data-qa="accountdetails-div-7f5mu">
    <v-flex v-if="params.defaultAccountType === 'TD'" data-qa="accountdetails-flex-mkg6bd">
      <DepositDetails
        :config="{ params }"
      />
    </v-flex>
    <div
      fluid
      v-if="casaAccountsTypes.includes(params.defaultAccountType)"
     data-qa="accountdetails-div-gfo1vr">
      <CasaDetails
        :config="{ params }"
      />
    </div>
    <v-flex class="my-4" data-qa="accountdetails-flex-mdq8m">
      <v-divider data-qa="accountdetails-divider-ntexz8"></v-divider>
    </v-flex>
    <v-flex class="mb-1" v-if="tips.enabled" data-qa="accountdetails-flex-w96e2b">
      <v-alert icon="mdi-information-outline" class="v-alert--info"
        v-for="(tip, i) in tips.tipMessages"
        :data-qa="`accountdetails-alert-${i}`"
        :key="tip">
          <font class="body-2 font-weight-regular">
            {{ $t(`screenTips.${tip}`) }}
          </font>
      </v-alert>
    </v-flex>
  </div>
</template>

<script>
import CasaDetails from '@/views/accounts/accountDetails/CasaDetails'
import DepositDetails from '@/views/accounts/accountDetails/DepositDetails'

export default {
  name: 'AccountDetails',
  components: {
    CasaDetails,
    DepositDetails
  },
  data () {
    return {
      tips: {
        enabled: false,
        tipMessages: []
      },
      casaAccountsTypes: ['SVGS', 'CACC', 'NACC', 'TXSV', 'TXNA', 'TXFR', 'TXEA', 'TXLA'],
      params: {
        accountId: '',
        accountName: '',
        accountStatus: '',
        defaultAccountType: '',
        navToTab: 0
      }
    }
  },
  beforeMount () {
    if (!this.params.accountId) {
      this.goBack()
    }
  },
  created () {
    this.setRouteParams()
    if (!this.params.accountId) {
      this.$router.push('Savings')
    }
    this.setTips(this.params.defaultAccountType)
  },
  methods: {
    setRouteParams () {
      if (this.$route.params) {
        const params = this.$route.params || {}
        this.params.accountId = params.accountId ?? ''
        this.params.accountName = params.accountName ?? ''
        this.params.defaultAccountType = params.accountType ?? ''
        this.params.accountStatus = params.accountStatus ?? ''
        this.params.accountOwnership = params.accountOwnership ?? ''
        this.params.productName = params.product?.productDescription ?? ''
        this.params.iban = params.product?.iban ?? ''
        this.params.navToTab = params.navToTab ?? 0
        this.params.noticeId = params.noticeId ?? ''
      }
    },
    goBack () {
      return this.$router.go(-1)
    },
    setTips (accountType) {
      if (accountType === 'TD') {
        this.tips = this.$appSettings.screenTips.deposits
      } else if (accountType === 'SVGS') {
        this.tips = this.$appSettings.screenTips.savings
      } else if (accountType === 'CACC') {
        this.tips = this.$appSettings.screenTips.current
      }
    }
  }
}
</script>
